<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M220.179 159.155L202.016 145.67C201.518 139.77 199.367 134.029 195.53 129.03C194.324 127.456 191.795 126.97 191.521 126.643C189.306 123.974 186.267 128.768 183.892 133.882C183.426 133.882 182.966 133.939 182.519 134.035V120.794H158.196V154.784H165.104L159.435 162.458C158.203 164.128 157.858 166.176 158.318 168.051L157.341 169.158L140.985 169.248C148.026 176.666 154.774 180.851 161.331 182.259C165.487 183.155 168.628 183.898 173.077 182.95L191.629 196.723L220.185 159.142L220.179 159.155Z"
      class="fill-brand-100"
    />
    <path
      d="M176.665 187.472L207.442 145.806L246.151 174.542C249.363 176.927 250.039 181.474 247.661 184.694L225.504 214.69C223.126 217.91 218.59 218.588 215.378 216.204L176.668 187.467L176.665 187.472Z"
      class="fill-secondary-500"
    />
    <path
      d="M132.456 187.488V23.3792C132.456 20.0107 129.732 17.28 126.372 17.28L10.5528 17.28C7.19272 17.28 4.46882 20.0107 4.46882 23.3792L4.46882 187.488C4.46882 190.857 7.19272 193.587 10.5528 193.587H126.372C129.732 193.587 132.456 190.857 132.456 187.488Z"
      class="fill-secondary-500"
    />
    <path
      d="M154.57 210.566V46.4576C154.57 43.0891 151.846 40.3584 148.486 40.3584L32.6671 40.3584C29.307 40.3584 26.5831 43.0891 26.5831 46.4576L26.5831 210.566C26.5831 213.935 29.307 216.666 32.6671 216.666H148.486C151.846 216.666 154.57 213.935 154.57 210.566Z"
      class="fill-brand-100"
    />
    <path
      d="M178.006 233.12V69.0112C178.006 65.6427 175.282 62.912 171.922 62.912L56.1026 62.912C52.7425 62.912 50.0186 65.6427 50.0186 69.0112L50.0186 233.12C50.0186 236.488 52.7425 239.219 56.1026 239.219H171.922C175.282 239.219 178.006 236.488 178.006 233.12Z"
      class="fill-brand-500"
    />
    <path
      d="M195.652 129.19L179.8 109.248C179.449 109.709 179.015 110.202 178.517 110.701L176.946 112.435C175.823 113.408 174.144 113.722 173.231 112.666C173.231 112.666 169.93 109.875 167.83 106.598C167 105.306 166.604 102.938 166.649 101.325C165.595 101.626 164.587 102.138 163.68 102.861C159.965 105.83 159.352 111.302 162.308 115.021L182.143 139.968C185.105 143.693 190.563 144.307 194.273 141.344C197.988 138.374 198.601 132.902 195.645 129.184L195.652 129.19Z"
      class="fill-brand-100"
    />
    <path
      d="M167.836 106.605C169.937 109.882 173.237 112.672 173.237 112.672C174.15 113.722 175.829 113.414 176.953 112.442L178.523 110.707C179.021 110.214 179.455 109.715 179.806 109.254L175.823 104.243C173.588 101.427 169.924 100.39 166.662 101.331C166.617 102.938 167.013 105.306 167.843 106.605H167.836Z"
      class="fill-brand-300"
    />
    <path
      d="M155.017 90.2528H90.7427V97.6704H155.017V90.2528Z"
      class="fill-brand-100"
    />
    <path
      d="M73.2886 101.53C77.4597 101.53 80.841 98.1399 80.841 93.9584C80.841 89.7769 77.4597 86.3872 73.2886 86.3872C69.1176 86.3872 65.7363 89.7769 65.7363 93.9584C65.7363 98.1399 69.1176 101.53 73.2886 101.53Z"
      class="fill-brand-100"
    />
    <path
      d="M155.017 122.867H90.7427V130.285H155.017V122.867Z"
      class="fill-brand-100"
    />
    <path
      d="M73.2886 134.15C77.4597 134.15 80.841 130.761 80.841 126.579C80.841 122.398 77.4597 119.008 73.2886 119.008C69.1176 119.008 65.7363 122.398 65.7363 126.579C65.7363 130.761 69.1176 134.15 73.2886 134.15Z"
      class="fill-brand-100"
    />
    <path
      d="M155.017 155.488H90.7427V162.906H155.017V155.488Z"
      class="fill-brand-100"
    />
    <path
      d="M73.2886 166.771C77.4597 166.771 80.841 163.381 80.841 159.2C80.841 155.019 77.4597 151.629 73.2886 151.629C69.1176 151.629 65.7363 155.019 65.7363 159.2C65.7363 163.381 69.1176 166.771 73.2886 166.771Z"
      class="fill-brand-100"
    />
    <path
      d="M155.017 188.109H90.7427V195.526H155.017V188.109Z"
      class="fill-brand-100"
    />
    <path
      d="M73.2886 199.386C77.4597 199.386 80.841 195.996 80.841 191.814C80.841 187.633 77.4597 184.243 73.2886 184.243C69.1176 184.243 65.7363 187.633 65.7363 191.814C65.7363 195.996 69.1176 199.386 73.2886 199.386Z"
      class="fill-brand-100"
    />
    <path
      d="M141.949 229.53C141.905 229.53 141.853 229.53 141.809 229.53C140.5 229.491 139.268 228.922 138.387 227.955L128.543 217.139C126.749 215.162 126.883 212.102 128.856 210.304C130.828 208.506 133.88 208.64 135.674 210.618L142.154 217.741L159.544 200.768C161.452 198.906 164.51 198.944 166.368 200.858C168.226 202.771 168.188 205.837 166.279 207.699L145.314 228.16C144.413 229.043 143.201 229.53 141.949 229.53Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'InsuranceTerms'
  }
</script>
